module.exports = __webpack_public_path__ + "assets/e159a7ec5ff91b33638f5d03d37fe8e6.png";